import { render, staticRenderFns } from "./asset-bar-download.vue?vue&type=template&id=051b7c49&"
import script from "./asset-bar-download.vue?vue&type=script&lang=js&"
export * from "./asset-bar-download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports